var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"provider"},[(_vm.loadedAllProviders)?[(_vm.provider)?_c('ProviderHeader',{attrs:{"provider":_vm.provider}}):_vm._e(),_c('router-view',{attrs:{"provider":_vm.provider}})]:[_c('Loading',{attrs:{"text":"Loading care provider..."}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }